import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, firebaseSignOut } from "../firebaseConfig";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { updateProfile } from "firebase/auth";

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [newNickname, setNewNickname] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
    }
  };
  
  const handleUpload = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setError("Пожалуйста, выберите изображение.");
      return;
    }
  
    setLoading(true);
    const storage = getStorage();
    const storageRef = ref(storage, "profile_images/" + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file);
  
    uploadTask.on(
      "state_changed",
      (snapshot) => {
      },
      (err) => {
        setError("Ошибка загрузки изображения");
        setLoading(false);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        
        try {
          await updateProfile(auth.currentUser, {
            photoURL: downloadURL,
          });
          setSuccess("Фото профиля успешно обновлено!");
          setLoading(false);
        } catch (err) {
          setError("Ошибка при обновлении фото профиля.");
          setLoading(false);
        }
      }
    );
  };  

  const handleNicknameChange = async (e) => {
    e.preventDefault();
    
    try {
      await updateProfile(auth.currentUser, {
        displayName: newNickname,
      });
      setSuccess("Никнейм успешно обновлен!");
    } catch (err) {
      setError("Ошибка при изменении никнейма.");
    }
  };  

  const handleLogout = async () => {
    try {
      await firebaseSignOut(auth);
      navigate("/auth/login");
    } catch (err) {
      console.error("Ошибка при выходе:", err);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate("/auth/login");
      } else {
        setUser(user);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (!user) return <p>Загрузка...</p>;

  return (
    <div className="container">
      <div className="home-container">
        <h1>Raytolfas - Профиль</h1>
      </div>

      <div className="content-container">
        <h1>Профиль</h1>
        <p>Имя: {user.displayName || "Нет имени"}</p>
        <p>Email: {user.email || "Нет email"}</p>
        {user.photoURL ? (
          <img src={user.photoURL} alt="Аватар" className="profile" />
        ) : (
          <p>Нет аватара</p>
        )}
        <button onClick={handleLogout}>Выйти</button>

        <form onSubmit={handleNicknameChange}>
          <div>
            <label>Новый никнейм</label>
            <input
              type="text"
              value={newNickname}
              onChange={(e) => setNewNickname(e.target.value)}
              requireds
            />
          </div>
          <button type="submit">Изменить никнейм</button>
        </form>

        <form onSubmit={handleUpload}>
          <div>
            <label>Выберите фото</label>
            <input type="file" onChange={handleFileChange} accept="image/*" />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Загружается..." : "Загрузить фото"}
          </button>
        </form>
        {error && <p>{error}</p>}
        {success && <p>{success}</p>}
      </div>
    </div>
  );
};

export default ProfilePage;
